import { TreasuryOfferBaseEntity } from '@genial/services';
import {
  RiskResponseFilter,
  type ResponsesTreasuryWithdrawItemResponse,
} from '@genial/services/dist/models';
import { useSetRecoilState } from 'recoil';

import type { DirectTreasuryOperationType } from '../../../pages/NewApplication/Product/components/Equity/constants';
import {
  directTreasuryOffersParams,
  directTreasuryOffersBySearchTermParams,
  updateDirectTreasuryOffersAllSelector,
  updateDirectTreasuryOffersBySearchTermSelector,
  updateDirectTreasuryProductItemAmountSelector,
  updateDirectTreasuryProductItemPriceSelector,
  directTreasuryOffersByFilterParams,
  updateDirectTreasuryProductDetailSelectedSelector,
  updateDirectTreasuryMarketStatusSelector,
  updateDirectTreasuryIndexerOptionsFilterSelector,
  updateDirectTreasuryRisksOptionsFilterSelector,
  updateDirectTreasuryOffersOperationTypeSelector,
  directTreasuryRescueOffersParams,
  updateDirectTreasuryRescueOffersAllSelector,
  updateDirectTreasuryRescueOffersBySearchTermSelector,
  directTreasuryRescueOffersBySearchTermParams,
} from '../selectors';
import {
  DirectTreasuryOffersByFilterParams,
  DirectTreasuryOffersBySearchTerm,
  DirectTreasuryOffersParams,
  type DirectTreasuryRescueOffersBySearchTerm,
} from '../types';

export const useDirectTreasuryActions = () => {
  const setDirectTreasuryOffersByFilterParams = useSetRecoilState(
    directTreasuryOffersByFilterParams
  );
  const setDirectTreasuryAllOffers = useSetRecoilState(updateDirectTreasuryOffersAllSelector);
  const setDirectTreasuryRescueAllOffers = useSetRecoilState(
    updateDirectTreasuryRescueOffersAllSelector
  );

  const setDirectTreasuryBySearchTermOffers = useSetRecoilState(
    updateDirectTreasuryOffersBySearchTermSelector
  );
  const setDirectTreasuryRescueBySearchTermOffers = useSetRecoilState(
    updateDirectTreasuryRescueOffersBySearchTermSelector
  );
  const setDirectTreasuryOffersParams = useSetRecoilState(directTreasuryOffersParams);
  const setDirectTreasuryRescueOffersParams = useSetRecoilState(directTreasuryRescueOffersParams);

  const setDirectTreasuryOffersBySearchTermParams = useSetRecoilState(
    directTreasuryOffersBySearchTermParams
  );
  const setDirectTreasuryRescueOffersBySearchTermParams = useSetRecoilState(
    directTreasuryRescueOffersBySearchTermParams
  );
  const setDirectTreasuryIndexerOptionsFilter = useSetRecoilState(
    updateDirectTreasuryIndexerOptionsFilterSelector
  );
  const setDirectTreasuryRisksOptionsFilter = useSetRecoilState(
    updateDirectTreasuryRisksOptionsFilterSelector
  );

  const setProductItemAmount = useSetRecoilState(updateDirectTreasuryProductItemAmountSelector);
  const setProductItemPrice = useSetRecoilState(updateDirectTreasuryProductItemPriceSelector);

  const setDirectTreasuryMarketStatus = useSetRecoilState(updateDirectTreasuryMarketStatusSelector);

  const setProductDetailSelected = useSetRecoilState(
    updateDirectTreasuryProductDetailSelectedSelector
  );

  const setDirectTreasuryOffersOperationType = useSetRecoilState(
    updateDirectTreasuryOffersOperationTypeSelector
  );

  const updateDirectTreasuryOffersByFilterParams = (
    value: Partial<DirectTreasuryOffersByFilterParams>
  ) => {
    setDirectTreasuryOffersByFilterParams(value);
  };

  const updateDirectTreasuryOffersParams = (value: Partial<DirectTreasuryOffersParams>) => {
    setDirectTreasuryOffersParams(value);
  };

  const updateDirectTreasuryRescueOffersParams = (value: Partial<DirectTreasuryOffersParams>) => {
    setDirectTreasuryRescueOffersParams(value);
  };

  const updateDirectTreasuryOffersBySearchTermParams = (
    value: Partial<DirectTreasuryOffersBySearchTerm>
  ) => {
    setDirectTreasuryOffersBySearchTermParams(value);
  };

  const updateDirectTreasuryRescueOffersBySearchTermParams = (
    value: Partial<DirectTreasuryRescueOffersBySearchTerm>
  ) => {
    setDirectTreasuryRescueOffersBySearchTermParams(value);
  };

  const updateDirectTreasuryAllOffers = (value: TreasuryOfferBaseEntity[]) => {
    setDirectTreasuryAllOffers(value);
  };

  const updateDirectTreasuryRescueAllOffers = (value: ResponsesTreasuryWithdrawItemResponse[]) => {
    setDirectTreasuryRescueAllOffers(value);
  };

  const updateDirectTreasuryBySearchTermOffers = (value: TreasuryOfferBaseEntity[]) => {
    setDirectTreasuryBySearchTermOffers(value);
  };

  const updateDirectTreasuryRescueBySearchTermOffers = (
    value: ResponsesTreasuryWithdrawItemResponse[]
  ) => {
    setDirectTreasuryRescueBySearchTermOffers(value);
  };

  const updateProductItemAmount = (value: number) => {
    setProductItemAmount(value);
  };

  const updateProductItemPrice = (value: number) => {
    setProductItemPrice(value);
  };

  const updateDirectTreasuryDetailSelected = (item: TreasuryOfferBaseEntity) => {
    setProductDetailSelected(item);
  };

  const updateDirectTreasuryIndexerOptionsFilter = (value: RiskResponseFilter[]) => {
    setDirectTreasuryIndexerOptionsFilter(value);
  };

  const updateDirectTreasuryRisksOptionsFilter = (value: RiskResponseFilter[]) => {
    setDirectTreasuryRisksOptionsFilter(value);
  };

  const updateDirectTreasuryOffersOperationType = (value: DirectTreasuryOperationType) => {
    setDirectTreasuryOffersOperationType(value);
  };

  return {
    updateDirectTreasuryOffersParams,
    updateDirectTreasuryOffersByFilterParams,
    updateDirectTreasuryOffersBySearchTermParams,
    updateDirectTreasuryAllOffers,
    updateDirectTreasuryBySearchTermOffers,
    updateProductItemAmount,
    updateProductItemPrice,
    updateDirectTreasuryDetailSelected,
    setDirectTreasuryMarketStatus,
    updateDirectTreasuryIndexerOptionsFilter,
    updateDirectTreasuryRisksOptionsFilter,
    updateDirectTreasuryOffersOperationType,
    updateDirectTreasuryRescueOffersParams,
    updateDirectTreasuryRescueAllOffers,
    updateDirectTreasuryRescueBySearchTermOffers,
    updateDirectTreasuryRescueOffersBySearchTermParams,
  };
};
